// import Keycloak from "keycloak-js";

// console.log("✅ Cargando Keycloak...");

// const keycloak = new Keycloak({
//     url: "http://keycloak.localhost:9193/",
//     realm: "groupama",
//     clientId: "welcome-page-app2",
// });

// console.log("🟢 Keycloak cargado:", keycloak);
// export default keycloak;


import Keycloak from "keycloak-js";
import { readRuntimeConfig } from "./config/runtime";

const { realm, keycloakBaseUrl } = readRuntimeConfig();

const keycloak = new Keycloak({
  url: keycloakBaseUrl,
  realm,
  clientId: "welcome-page-app2",
});

export default keycloak;